export const MouraLogo = () => {
  return (
    <img
      src="https://www.moura.com.br/_next/static/media/logo-moura.a65f0a86.svg?dpl=dpl_HH2gn7FDvWmhAVvhEDWzfB31PPv5"
      alt="Grupo Moura"
      style={{
        height: '32px',
        width: 'auto',
        margin: '10px',
      }}
    />
  );
};

export const MouraLogoIcon = () => {
  // Simplificando para o ícone (o "M" estilizado)
  return (
    <img
      src="https://www.moura.com.br/_next/static/media/logo-moura.a65f0a86.svg?dpl=dpl_HH2gn7FDvWmhAVvhEDWzfB31PPv5"
      alt="M"
      style={{
        height: '32px',
        width: '32px',
        objectFit: 'cover',
        objectPosition: 'left',
      }}
    />
  );
};
